module.exports = __webpack_public_path__ + "static/media/socialPiper-schedule-tabletPro-en.fc75dc7b.png";